<template>
  <div class="field">
    <label
      v-if="label"
      class="label"
    >
      {{ label }}
      <FieldHelp :text="help" />
    </label>
    <div
      v-for="opt in options"
      :key="opt.value"
      class="control checkbox-field"
    >
      <input
        :id="compositeId(opt.value)"
        type="checkbox"
        :name="opt.value"
        :checked="modelValue.value[opt.value]"
        @change="onChange"
      >
      <label
        :for="compositeId(opt.value)"
        class="checkbox"
        style="margin-left: 0.75em;"
        v-html="opt.label"
      />
    </div>
  </div>
</template>

<script>
import FieldHelp from './FieldHelp.vue';

export default {
  components: {
    FieldHelp,
  },
  props: {
    id: String,
    help: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    modelValue: {
      type: Object,
      default() {
        return {
          one: true,
          two: false,
        };
      },
    },
    options: {
      type: Array,
      default() {
        return [
          { value: 'one', label: 'option one' },
          { value: 'two', label: 'option two' },
        ];
      },
    },
  },
  emits: ['update:modelValue'],
  methods: {
    onChange(event) {
      const newModel = this.modelValue;
      newModel.value[event.target.name] = event.target.checked;
      this.$emit('update:modelValue', newModel);
    },
    compositeId(option) {
      return `${this.id}-${option}`;
    },
  },
};
</script>

<style scoped>
.checkbox-field {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 0.25em;
}
</style>
